<template>
  <form class="side_box" :style="style" c>
    <div v-if="!isEditing" class="flowname">
      <label for="ref">Name</label>
      <span v-if="this.details.name">{{this.details.name}}</span>
      <span v-else>  /  </span>
    </div>
    <InputDash
      v-else       
      label="Name"
      name="name"
      :isTextArea="false"
      placeholder="Flow name"
      :isDisabled="false"
      v-model="flowname"
      :validation="!this.inValidFields.includes('flowname')"
    />
    <div class="devices">
      <label for="ref" :class="isEditing ? 'editing' : ''">Linked Devices</label>
      <span class="span-wordwrap" v-if="this.details.linkedDevices && this.details.linkedDevices.length > 0">
        {{
          this.details.linkedDevices.map(function(elem){
              return elem.deviceRef;
          }).join(' | ')
        }}
      </span>
      <span class="span-wordwrap" v-else-if="this.details.linkedDevices && this.details.linkedDevices.length == 0">No devices linked</span>     
      <span  class="span-wordwrap" v-else>  /  </span>
    </div>
    <div class="container flex-col">
      <VerticalStepBullets class="steps-bullets" :totalSteps="this.newSteps.length" :currentStep="this.newSteps.length" />
      <div class="steps-list" v-if="!isEditing">
        <div 
          class="step-group"
          v-for="(step, index) in this.newSteps" 
          :key="index"
        >
          <label for="ref">{{step.name}}</label>
        </div>
      </div>

      <draggable v-else :list="this.newSteps" class="steps-list" :move="checkMove" @start="drag=true" @end="drag=true">
        <div 
          class="step-group group-w-button"
          v-for="(step, index) in this.newSteps" 
          :key="index"
        >
          <input autocomplete="off" :class="{'autocomplete-active': autocompleteIndex == index}" type="text" :name="`newsteps[${index}][name]`" v-model="step.name" placeholder="Search" @input="updateSteps(index)" @focus="openComplete(index)"/>
          <input autocomplete="off" type="text" :name="`newsteps[${index}][stepID]`" v-model="step.stepID" style="display:none;" /> 
          <BaseIcon name="times-circle" class="icon ico-delete" :class="{'delete-disabled': newSteps.length == 1}" @click.native="removeStep(index)"/>
          <BaseIcon name="bars" class="icon ico-move " :class="{'autocomplete-active': autocompleteIndex == index}"/>

          <AutocompleteList v-if="autocompleteIndex == index && stepsResult.length > 0" :searchResults="stepsResult" @selectedStep="gotSelectionStep" class="autocomplete" />
        </div>
        <div class="add-step-button" @click="addNewStep">
          <BaseIcon name="plus-circle" class="icon" />
          <label>Add production step</label>  
        </div>
      </draggable>
    </div>
      <div v-if="!isEditing" class="icon submit" @click="startEditing">
        <BaseIcon name="pen" class="icon" />
      </div>
      <button v-if="isEditing" class="no-btn icon submit" @click="stopEditing">
        <BaseIcon name="save" class="icon" />
      </button>
  </form>
</template>


<script>
import BaseIcon from "@/components/base/Icon";
import InputDash from "@/components/base/InputDash.vue";
import VerticalStepBullets from "@/components/base/VerticalStepBullets.vue";
import AutocompleteList from "@/components/base/AutocompleteList";
import draggable from 'vuedraggable'


export default {
  components: {
    BaseIcon, 
    InputDash,
    draggable,
    VerticalStepBullets,
    AutocompleteList
  },
  computed: {
    style() {
      return 'height: ' + this.height + '%';
    }
  },
  props: {
    height: String,
    details: Object,
  },
  mounted() {
    this.setStartValues()
  },
  data() {
    return{
      stepsResult: [],
      newSteps: [],
      isEditing: false,
      autocompleteIndex: 99999,
      flowname: "",
      flowref: "",
      flowID: "",
      inValidFields: []
    }
  },
  watch:{
    details: {
      handler: function() {
        this.isEditing = false
        this.setStartValues()
      },
    }
  },
  methods: {
    setStartValues(){
      this.flowID = this.details.flowID
      this.flowref = this.details.ref
      this.flowname = this.details.name
      this.newSteps = []
      for(var i = 0; i < this.details.customStep.length; i++) {
        let step = {stepID: this.details.customStep[i].stepID, name: this.details.customStep[i].name, order: this.details.customStep[i].order}
        this.newSteps.push(step)
      }

      this.newSteps.sort((a, b) => (a.order > b.order) ? 1 : -1)

    },
    startEditing() {
      this.isEditing = true
    },
    putStep: function () {
      var that = this

      for(var i = 0; i < this.newSteps.length; i++) {
        this.newSteps[i].order = i+1
      }
      
      this.$http.put(this.$endpoint + 'management/productionFlow/flow', {
        "flowID": this.flowID,
        "ref": this.flowref,
        "name": this.flowname,
        "steps": this.newSteps
      })
      .then(function (response) {
        that.$swal(
          'Prodution flow updated!',
          `Your production flow has been successfully updated.`,
          'success'
        );
        that.$emit('refresh', true);
      })
      .catch(function (error) {
        that.$swal(
          'Oops that went wrong?',
          `Please contact the admin with the following info: ${ error }`,
          'error'
        );
      });
    },
    stopEditing() {
      this.isEditing = false
      this.putStep()
    },
    checkMove: function(e) {
      // this.newSteps[e.draggedContext.index].order = e.draggedContext.futureIndex
      window.console.log("Future index: " + e.draggedContext.futureIndex);
    },
    addNewStep() {
      this.newSteps.push({
        stepID: '',
        name: '',
        order: ''
      })
    },
    updateSteps(index) {
      this.getSteps(index)
    },
    getSteps(index) {
      var that = this
      if (this.newSteps[index].name != "") {
        this.$http.get(this.$endpoint + 'management/productionStep/search/' + this.newSteps[index].name)
        .then(response => {
          that.stepsResult = response.data
        })
        .catch(error => {
          if (error.response.status === 401) {
            this.$store
            .dispatch("logout")
            .then(() => this.$router.push("/login"))
            .catch(err => console.log(err));
          } else {
            that.$swal(
              'Oops that went wrong?',
              `Please contact the admin with the following info: ${ error }`,
              'error'
            );
          }
        })
      }
    },
    removeStep(index) {
      if (this.newSteps.length > 1) {
        this.newSteps.splice(index, 1);
      }
    },
    openComplete(index) {
      this.autocompleteIndex = index
    },
    resetAutocompleteIndex(){
      this.autocompleteIndex = 99999
    },
    gotSelectionStep(selectedStep) {
      this.newSteps[this.autocompleteIndex].order = this.autocompleteIndex+1
      this.newSteps[this.autocompleteIndex].stepID = selectedStep.stepID
      this.newSteps[this.autocompleteIndex].name = selectedStep.name
      this.resetAutocompleteIndex()
      this.stepsResult = []
    },
  }
};
</script>

<style lang="scss" scoped>  
@import "@/style/base";
@import "@/style/components/sideBox";
@import "@/style/components/inputs";
@import "@/style/components/buttons";

.side_box {
  max-height: 690px;

  div.flowname {
    width: 100%;
    height: 59px;

    .span-wordwrap{
      width: 100%;
      word-break: break-word;
    }
  }

    div.devices {
    width: 100%;
    min-height: 59px;

    .editing {
      margin-top: 8px;
    }

    .span-wordwrap {
      width: 100%;
      height: 72px;
      line-height: 18px;
      overflow-y: auto;
      word-break: break-word;
    }
  }

  .container {
    width: 100%;
    margin-top: 24px;
    max-height: 70%;
    overflow-y: auto;
    display: flex;

    .steps-list {
      padding: 0 10px;
      width: 88%;

      .add-step-button{
        margin-top: 8px;
        height: 32px;
        display: flex;
        justify-content: center;
        align-items: center;
        align-content: center;
        color: #707070;

        label {
          padding: 0;
          padding-left: 8px;
          color: #C6C6C6 !important;
          margin: 0 !important;
        }

        .icon {
          color: #C6C6C6;
        }
      }

      label {
        width: 100%;
        padding: 5px 6px;
        font-family: Montserrat;
        font-weight: 500;
        font-size: 14px;
        text-align: left;
        color: #707070;

        &+label{
          margin-top: 62px;
        }
      }

      input {
        margin-bottom: 0;
        width: 88%;
        &+input {
          margin-top: 28px;
        }
      }
      .autocomplete {
        margin-top: -6px !important;
      }

      .step-group + .step-group {
        & > label {
          margin-top: 38px;
        }
        & > input {
          margin-top: 28px;
          width: 88%;
        }

        .autocomplete {
          margin-top: -6px !important;
        }
      }

      .step-group.group-w-button {
        .icon {
          margin-top: 28px;
          position: absolute;
          bottom: 8px;
            
            &.autocomplete-active {
              z-index: 102;
            }

          &.ico-move {
            right: 16%;
            color: #707070;
          }

          &.ico-delete {
            right: 4%;
            color: #F27C7C;
          }

          &:hover {
            cursor: all-scroll;
          }
          
          &.delete-disabled {
            color: #707070 !important;
          }
        }
      }
    }

    label {
      height: 20px;
    }

    input, span{
      height: 30px;
      margin-bottom: 15px;

      &.autocomplete-active {
        z-index: 101;
      }
    }
  }
}
</style>
